header {
  position: relative;
  display: flex;
  width: auto;
  height: calc(var(--space-unit) * 6);
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: var(--border-size-medium) solid var(--color-surface03);
  background-color: var(--color-surface01);
  border-radius: var(--border-radius) var(--border-radius) var(--border-no-radius) var(--border-no-radius);
}

slot[name="aria-heading"]::slotted(*) {
  position: absolute;
  overflow: hidden !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  border: 0 none !important;
  margin: -1px !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
}

header.real,
header.trial,
header.temp {
  border-bottom: var(--border-size-medium) solid var(--blue100);
  background-color: var(--color-primary03);
}

.card-title {
  overflow: hidden;
  height: calc(var(--space-unit) * 2);
  padding: calc(var(--space-unit) * 2);
  margin: 0;
  color: var(--color-surface05);
  font-family: var(--font-family-sans);
  font-size: 12px;
  font-weight: var(--font-sb);
  letter-spacing: 0.22px;
  line-height: calc(var(--space-unit) * 2);
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.faded {
  border-bottom: var(--border-size-medium) solid var(--color-background);
}

.faded.real,
.faded.trial,
.faded.temp {
  border-top: var(--border-size-medium) solid var(--blue100);
  border-right: var(--border-size-medium) solid var(--blue100);
  border-left: var(--border-size-medium) solid var(--blue100);
}
